import React from 'react';
import "./AboutBanner.css"

const AboutBanner = () => {
    return (
        <div>
            <div className='aboutContainer'>
                <div className='text-white font-bold text-4xl aboutText container mx-auto p-6 lg:p-24'>
                    <h2>We Are Pride Shipping Lines</h2>
               </div>
            </div>
        </div>
    );
};

export default AboutBanner;